import { z } from "zod/v4";

import {
  OfferProductVariantDto,
  OfferProductVariantDtoSchema,
} from "../dtos/offer-products";
import {
  DiscountApplicationMethodList,
  DiscountApplicationTypeList,
} from "../dtos/offers";
import { WidgetCategory, WidgetCategoryList } from "../dtos/widgets";

import { ModKeysList } from "./personalizations";

export const OfferTierUnitFieldList = [
  "minimumUnits",
  "maximumUnits",
  "unitDiscount",
] as const;
export type OfferTierUnitFieldType = (typeof OfferTierUnitFieldList)[number];

export const ScratchCardOfferTypeList = [
  "discount-product",
  "discount-order",
  "discount-custom",
  "volume-discount",
  "free-shipping",
  "free-gift",
] as const;
export type ScratchCardOfferType = (typeof ScratchCardOfferTypeList)[number];

export const ScratchCardSchema = z.object({
  title: z.string(),
  description: z.string(),
  modType: z.enum(ModKeysList),
  id: z.string(),
  backgroundColor: z.string().optional(),
});

export type ScratchCard = z.infer<typeof ScratchCardSchema>;

export const ScratchOfferCardSchema = ScratchCardSchema.extend({
  discountType: z.enum(DiscountApplicationTypeList),
  discountMethod: z.enum(DiscountApplicationMethodList).optional(),
});

export type ScratchOfferCard = z.infer<typeof ScratchOfferCardSchema>;

export const OfferComponentCardSchema = z.object({
  id: z.enum(WidgetCategoryList),
  title: z.string(),
  description: z.string(),
  image: z.any(),
});

export type OfferComponentCard = z.infer<typeof OfferComponentCardSchema>;

export const OfferPageList = [
  "settings",
  ...WidgetCategoryList,
  "enable",
] as const;
export type OfferPageType = (typeof OfferPageList)[number];

const OfferFlowConfigSchema = z.object({
  enabledSteps: z.array(z.enum(OfferPageList)),
});
export type OfferFlowConfig = z.infer<typeof OfferFlowConfigSchema>;

export const QuantityButtonProductVariantSchema =
  OfferProductVariantDtoSchema.extend({
    productTitle: z.string(),
    productId: z.string(),
  });

export type QuantityButtonProductVariant = z.infer<
  typeof QuantityButtonProductVariantSchema
>;
